// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__39Zyo","content":"LoadingAlert_content__j9Xxs"};